import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";


const deleteReview = async (payload: any)=>{
    const { data } = await axios.delete(Apis.DELETE_REVIEWS, {
        data: payload,
        headers: { Authorization: getToken() }
    });
    return data;
}

export default deleteReview;